module.exports = __webpack_public_path__ + "static/media/bg.cbc20d5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpg
// module id = 184
// module chunks = 0